module.exports = __webpack_public_path__ + "img/class7.1f2838c3.webp";